/* eslint-disable max-len */
import * as React from "react";
import { Button, Divider, Grid, Tab, Segment } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";
import { Authorize } from "reauthorize";

import { CoreDetailProps, DetailProps } from "../Detail";
import DeleteButton from "../DeleteButton";
import { ADMIN_ROLES } from "../../../../auth";

import { Link } from "redux-little-router";

export const CoreDetails: React.SFC<CoreDetailProps> = (props) => (
    <Grid>
        <Detail label="First Name" value={props.sraCustomerUser.firstName} labelWidth={5} valueWidth={11} />
        <Detail label="Last Name" value={props.sraCustomerUser.lastName} labelWidth={5} valueWidth={11} />
        <Detail label="Department" value={props.sraCustomerUser.department && props.sraCustomerUser.department.name} labelWidth={5} valueWidth={11} />
        <Detail label="Email Address" value={props.sraCustomerUser.emailAddress} labelWidth={5} valueWidth={11} />
        <Detail label="Roles" value={props.sraCustomerUser.roles && props.sraCustomerUser.roles.join(", ")} labelWidth={5} valueWidth={11} />
    </Grid>
);

const CoreDetailsWithActions: React.SFC<DetailProps> = (props) => {
    return (
        <div>
            <CoreDetails sraCustomerUser={props.sraCustomerUser} />

            <Divider />
            <Segment basic clearing vertical>
                <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name]}>
                    <DeleteButton />
                    <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${props.path}/edit`} />
                </Authorize>
            </Segment>
        </div>
    );
};

export const coreDetailsTab = (props: DetailProps) => ({
    path: "",
    menuItem: "Details",
    render: () => <Tab.Pane><CoreDetailsWithActions {...props} /></Tab.Pane>
});
